/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MedicationAdministrationByProcessAliases {
  ADMINISTRATION_BY_PROCESS_BARCODE = 'administration-by-process-barcode',
  ADMINISTRATION_BY_PROCESS_BARCODE_PANEL = 'administration-by-process-barcode-panel',
  ADMINISTRATION_BY_PROCESS_BUTTON = 'administration-by-process-button',
  ADMINISTRATION_BY_PROCESS_BUTTON_PANEL_PADDING = 'administration-by-process-button-panel-padding',
  ADMINISTRATION_BY_PROCESS_CARD = 'administration-by-process-card',
  ADMINISTRATION_BY_PROCESS_DECK = 'administration-by-process-deck',
  ADMINISTRATION_BY_PROCESS_HOUR_FIELD = 'administration-by-process-hour-field',
  ADMINISTRATION_BY_PROCESS_HOUR_PANEL = 'administration-by-process-hour-panel',
  ADMINISTRATION_BY_PROCESS_HOUR_TEXT = 'administration-by-process-hour-text',
  ADMINISTRATION_BY_PROCESS_JUSTIFICATION_FIELD = 'administration-by-process-justification-field',
  ADMINISTRATION_BY_PROCESS_JUSTIFICATION_FORM = 'administration-by-process-justification-form',
  ADMINISTRATION_BY_PROCESS_JUSTIFICATION_PANEL = 'administration-by-process-justification-panel',
  ADMINISTRATION_BY_PROCESS_JUSTIFICATION_TEXT_AREA = 'administration-by-process-justification-text-area',
  ADMINISTRATION_BY_PROCESS_LAYOUT = 'administration-by-process-layout',
  ADMINISTRATION_BY_PROCESS_LIST_PANEL = 'administration-by-process-list-panel',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LEGENDS_ADMINISTRATION_BY_PROCESS = 'legends-administration-by-process',
}
export { MedicationAdministrationByProcessAliases };
